<!--
 * @Author: Junjie
 * @Date: 2022-10-27 14:34:35
 * @LastEditTime: 2022-10-27 16:30:59
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/general/docs/modules/DocTypeTree.vue
-->
<template>
  <div class="tree-container">
    <div class="flex justify-between items-center pr-8px">
      <div class="top-text" v-if="!collapsed">文档类型</div>
      <div class="top-icon">
        <a-icon :type="collapsed ? 'double-right' : 'double-left'" @click="toggle" class="trigger" />
      </div>
    </div>
    <div class="pr-8px w-300px" v-show="!collapsed">
      <a-directory-tree :block-node="true" :load-data="loadChildTreeNode" :treeData="treeData" @select="handleSelect" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getAction } from '@/api/manage';

  export default {
    name: 'DocTypeTree',
    props: {
      value: {
        type: String,
        required: false
      },
      bizType: {
        type: String,
        required: false
      },
    },
    components: {

    },
    // 定义属性
    data () {
      return {
        collapsed: false,
        treeValue: null,
        loadedKeys: [],
        expandedKeys: [],
        treeData: [],
        url: {
          typeRootList: "/doc/commonDocsType/rootList",
          typeChildList: "/doc/commonDocsType/childList",
          getTypeChildListBatch: "/doc/commonDocsType/getChildListBatch",
        },
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      this.loadDocsTypeRoot()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      toggle () {
        this.collapsed = !this.collapsed
        this.$emit('update:collapsed', this.collapsed)
      },
      handleSelect (selectedKeys, treeNode) {
        const value = selectedKeys[0];
        if (value === this.treeValue) {
          return;
        } else if (!value) {
          this.$emit('change', '');
          this.treeValue = null
        } else {
          this.$emit('change', value);
          this.treeValue = value
        }
      },
      loadDocsTypeRoot () {
        const params = {};
        if (this.bizType) {
          params.bizType = this.bizType;
        }
        getAction(this.url.typeRootList, params).then((res) => {
          if (res.success) {
            if (res.result.records) {
              const nodes = this.getDataByResult(res.result.records);
              this.treeData = nodes;
            }
          } else {
            this.$message.warning(res.message)
          }
        });
      },
      loadChildTreeNode (treeNode) {
        return new Promise(resolve => {
          getAction(this.url.typeChildList, { pid: treeNode.dataRef.id }).then((res) => {
            if (res.success) {
              if (res.result.records.length == 0) {
                treeNode.dataRef['isLeaf'] = true
                return;
              } else {
                const nodes = this.getDataByResult(res.result.records);
                treeNode.dataRef['children'] = nodes;
                this.treeData = [...this.treeData];
              }
            } else {
              this.$message.warning(res.message)
            }
          });
          resolve();
        });
      },
      getDataByResult (result) {
        if (result) {
          return result.map(item => {
            item.key = item.typeCode;
            item.title = item.typeName;
            item.isLeaf = !(item.hasChild === '1');
            return item
          });
        }
      },
    },
  }
</script>

<style lang='scss' scoped>

  .tree-container {
    transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
  }
  .top-text {
    font-weight: 400;
    font-size: 14px;
    flex: 1;
    text-align: center;
  }
  .top-icon {
    line-height: 12px;
    padding: 6px 0px;
    .trigger {
      line-height: 14px;
      padding: 0 6px;
      font-size: 14px;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }

</style>